import { Component, OnInit } from '@angular/core';
import { PatientService } from 'src/app/core/services/v2/patient.service';
import { UserService } from 'src/app/core/services/v2/user.service';
import { UtilsService } from 'src/app/core/services/v2/utils.service';
import { WindowLoaderService } from 'src/app/shared/components/window-loader/window-loader.service';

@Component({
   selector: 'app-patient-plan-details',
   templateUrl: './patient-plan-details.component.html',
   styleUrls: ['./patient-plan-details.component.scss']
})
export class PatientPlanDetailsComponent implements OnInit {
  plan: any;
  sortedPlans: any[] = [];
  planDetails: any[] = [];
  subscriptionPlans: any [] = [];
  selectedPlan: string = '';

  user: any = [];
  subscriptionType: number;
  selectedType: number = 0;
  activationType: string;
  userId: number;
  patientId: number;
  isActive: boolean;
  subscribedPlan: string;
    constructor(
      private loaderService: WindowLoaderService,
      private patientService:PatientService,
      private userService: UserService,
      private utils: UtilsService,
      

    ) { }

  ngOnInit() {
        this.getUserDetails();

    console.log("recived plan details",history.state.data)
        // Accessing the data passed through state
        this.plan = history.state.data;

        const receivedPlan = history.state.data;

        if (receivedPlan) {
          console.log("Received plan details:", receivedPlan);
          this.plan = receivedPlan;
          this.selectedPlan = receivedPlan; // If you want to auto-select the tab
        } else {
          console.warn("No plan data received from navigation state.");
        }

  }
  onTabClick(planName: string): void {
    console.log("plan name",planName);
    this.selectedPlan = planName;

  }
  getUserDetails() {
    this.loaderService.show();
    this.userService.getUserDetails().subscribe(
      (userDetails) => {
        this.user = userDetails;
        console.log("user", this.user);
        this.userId = userDetails.id;
        this.patientId = userDetails.patientId
        console.log("This is userId: ", this.userId);
        console.log("This is patientId: ", this.patientId);
        this.getPatientHealthSubscriptionByEmployerId();

      },
      (error) => { console.error(error); }
    );
  }
  
  
  getPatientHealthSubscriptionByEmployerId() {
    this.loaderService.show();
    this.patientService.getPatientSubscriptionDetailsByPatientId(this.user.patientId).subscribe(
      (res) => {
        // Check if the API call was successful
        if (res && res.resultStatus && res.resultStatus.isSuccess) {
          const result = res.result;

          console.log("Subscription Details:", result);
  
          this.subscribedPlan = result.subscriptionType.name;
  
          // Set the active status and subscriptionTypeId from the API response
          const active = result.active;
          this.selectedType = result.subscriptionTypeId;
          this.activationType = active ? "Activate" : "Deactivate";
  
          // Assign subscription plans from the API response
          this.planDetails = result.subscriptionPlans;
  
          // Sort the plans by PlanDisplayOrder in ascending order
          this.sortedPlans = this.planDetails.sort(
            (a, b) => a.planDisplayOrder - b.planDisplayOrder // Correct casing to match your API keys
          );
  
          // Set the first plan as the default selected plan, if available
          if (this.sortedPlans.length > 0) {
            this.selectedPlan = this.sortedPlans[0].planName; // Ensure casing matches API keys
          }
  
          // Show success message
          // this.utils.showMessageSnackBar(result.resultStatus.message || "Subscription details fetched successfully", false);
  
          // Update the subscription plan's active status (if needed)
          const selectedPlan = this.subscriptionPlans.find(plan => plan.id === this.selectedType);
          if (selectedPlan) {
            selectedPlan.active = active;
          }
  
        } else {
    
  
          // If the result contains errorMessages, show them, else show a default error message
          const errorMessage = res.resultStatus.errorMessages
            ? res.resultStatus.errorMessages.join(", ")
            : "Failed to fetch subscription details.";
  
          this.utils.showMessageSnackBar(errorMessage, true);
        }
  
        this.loaderService.hide();
      },
      (error) => {
        console.error("Error fetching subscription details:", error);
        this.loaderService.hide();
        this.utils.showMessageSnackBar("An error occurred while fetching subscription details.", true); // Generic error message for HTTP errors
      }
    );
  }
  
}

